import styled from '@emotion/styled'
import tw from 'twin.macro'

export const SelectWrapper = styled.div`
  ${tw`
    mt-12
    lg:pl-0
    md:pl-6
    w-full
    md:w-1/4
    md:float-right
  `}
  select {
    ${tw`
      mt-1
      block
      w-full
      pl-3
      pr-10
      py-2
      text-base
      border-gray-300
      focus:outline-none
      focus:border-indigo-500
      sm:text-sm
      rounded-md
      placeholder-purple-900
      text-purple-900
      appearance-none
    `}
  }
`
